export default "__VITE_ASSET__d6872ed6__"